import { P, Li, A, Part, LegalPage } from "@/components/legal";

const REVISION_DATE = "27 октября 2026 года";

export default function Privacy() {
  return (
    <LegalPage title="Политика обработки персональных данных" meta={`Редакция от ${REVISION_DATE} · версия 1.1`}>
          <Part n="1" title="Общие положения" first>
            <P>
              Настоящая политика определяет порядок обработки персональных данных и меры по
              обеспечению их безопасности на сайте Gride.pro (далее «сайт»). Политика
              действует в отношении всех данных, которые сайт может получить о посетителе:
              при отправке формы «получить разбор» и при обычном посещении сайта (журнал
              доступа, см. раздел 3).
            </P>
            <P>
              Политика составлена в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ
              «О персональных данных» и иными нормативными актами Российской Федерации в этой
              области.
            </P>
            <P>
              Отправляя форму на сайте, вы подтверждаете, что ознакомились с условиями этой
              политики и даёте согласие на обработку своих персональных данных на описанных
              ниже условиях. Если вы не согласны, не отправляйте форму.
            </P>
          </Part>

          <Part n="2" title="Оператор персональных данных">
            <P>
              Оператором персональных данных, обрабатываемых на сайте, является Григорьев
              Данил Сергеевич, физическое лицо без статуса индивидуального предпринимателя
              или самозанятого (далее «оператор»). Поскольку оператор не зарегистрирован ни
              как ИП, ни как самозанятый, у него нет ИНН и ОГРН как обязательных реквизитов
              субъекта предпринимательской деятельности, в этой политике они не указываются,
              так как их не существует.
            </P>
            <P>
              Связаться с оператором по вопросам обработки персональных данных можно:
            </P>
            <ul className="list-disc list-outside pl-6 space-y-2">
              <Li>
                в Telegram: <A href="https://t.me/d_evoluer">@d_evoluer</A>;
              </Li>
              <Li>
                по электронной почте:{" "}
                <A href="mailto:gridepro@yandex.ru" external={false}>gridepro@yandex.ru</A>.
              </Li>
            </ul>
          </Part>

          <Part n="3" title="Какие данные собираются">
            <P>
              Сайт не требует регистрации. Через форму «получить разбор» собираются следующие
              поля:
            </P>
            <ul className="list-disc list-outside pl-6 space-y-2">
              <Li>описание процесса: то, что вы своими словами пишете о задаче (обязательное поле);</Li>
              <Li>контакт для связи: Telegram, телефон или email (обязательное поле);</Li>
              <Li>число людей, занятых в процессе: необязательное поле;</Li>
              <Li>сколько часов в неделю процесс занимает: необязательное поле;</Li>
              <Li>ставка в рублях за час, если она указывалась при подборе на странице: необязательное поле;</Li>
              <Li>отметки «где живут данные» (таблицы, CRM, 1С, чаты, сайт, всё сразу): необязательные, вы выбираете сами;</Li>
              <Li>факт согласия с этой политикой и время, когда согласие было дано (по UTC): записывается в момент отправки формы.</Li>
            </ul>
            <P>
              Данные формы вводятся вами добровольно. Все эти поля вместе с заявкой уходят
              одним сообщением в Telegram оператора (см. раздел 7). Базы данных, где заявки
              накапливались бы отдельно, у сайта нет.
            </P>
            <P>
              Отдельно от формы работает журнал доступа. Сервер оператора (nginx) записывает в
              него IP-адрес, время, адрес запроса и user agent браузера по каждому обращению к
              сайту. Это касается всех посетителей, а не только тех, кто заполнил форму. Эти
              записи могут содержать персональные данные. Приложение, которое принимает
              заявку, IP-адрес не сохраняет и в Telegram не отправляет.
            </P>
            <P>
              Сайт не использует cookie для отслеживания поведения (см. раздел 11).
            </P>
          </Part>

          <Part n="4" title="Цели обработки">
            <P>Персональные данные обрабатываются для того, чтобы:</P>
            <ul className="list-disc list-outside pl-6 space-y-2">
              <Li>рассмотреть заявку и подготовить разбор процесса, который вы описали;</Li>
              <Li>связаться с вами по указанному контакту и прислать результат разбора;</Li>
              <Li>защитить сайт и обеспечить его работу, в том числе ограничить спам и автоматические массовые отправки формы.</Li>
            </ul>
            <P>Данные не используются для рекламной рассылки и не передаются в маркетинговых целях.</P>
          </Part>

          <Part n="5" title="Правовое основание обработки">
            <P>Обработка персональных данных ведётся на основании:</P>
            <ul className="list-disc list-outside pl-6 space-y-2">
              <Li>согласия субъекта персональных данных, которое даётся при отправке формы (п. 1 ч. 1 ст. 6 152-ФЗ);</Li>
              <Li>
                законного интереса оператора в защите сайта и его работоспособности: в части
                журнала доступа и ограничения частоты отправки формы по IP-адресу (п. 7 ч. 1
                ст. 6 152-ФЗ).
              </Li>
            </ul>
          </Part>

          <Part n="6" title="Срок хранения">
            <P>
              Единственный след заявки: сообщение в Telegram оператора. Оно хранится, пока
              оператор не удалит его сам, либо до вашего запроса на удаление или отзыва
              согласия, в зависимости от того, что наступит раньше. Автоматическое удаление
              по истечении фиксированного срока не настроено; при запросе на удаление (раздел
              8) сообщение удаляется вручную в течение 10 рабочих дней.
            </P>
            <P>
              Журналы доступа сервера ротируются ежедневно и хранятся 14 дней, затем
              удаляются.
            </P>
          </Part>

          <Part n="7" title="Кому передаются данные">
            <P>Для обработки заявки данные передаются:</P>
            <ul className="list-disc list-outside pl-6 space-y-2">
              <Li>
                в Telegram (Telegram Messenger Inc.): заявка уходит сообщением в бота оператора,
                оператор видит её в своём аккаунте и отвечает вам тоже через Telegram. Это
                единственный канал доставки заявки, резервного канала нет. Так как Telegram
                Messenger Inc. иностранная компания, эта передача является трансграничной
                передачей персональных данных в понимании ст. 12 152-ФЗ.
              </Li>
            </ul>
            <P>
              Сайт размещён на сервере оператора. Базы данных заявок нет, почтовые сервисы для
              пересылки заявок не используются. Подтвердить физическое расположение сервера
              оператор не может, поэтому эта политика не утверждает, где именно он находится.
            </P>
            <P>
              Оператор не продаёт и не передаёт персональные данные третьим лицам в
              рекламных или иных не связанных с обработкой заявки целях.
            </P>
          </Part>

          <Part n="8" title="Права субъекта персональных данных и как их реализовать">
            <P>В соответствии со ст. 14 152-ФЗ вы имеете право:</P>
            <ul className="list-disc list-outside pl-6 space-y-2">
              <Li>получить информацию о том, какие ваши данные обрабатываются и с какой целью;</Li>
              <Li>потребовать уточнить, заблокировать или удалить свои данные, если они неполные, устаревшие или обрабатываются без законного основания;</Li>
              <Li>отозвать согласие на обработку в любой момент;</Li>
              <Li>обратиться с жалобой в Роскомнадзор, если считаете, что ваши права нарушены.</Li>
            </ul>
            <P>
              Чтобы реализовать любое из этих прав, напишите оператору в Telegram{" "}
              <A href="https://t.me/d_evoluer">@d_evoluer</A> или на{" "}
              <A href="mailto:gridepro@yandex.ru" external={false}>gridepro@yandex.ru</A>. Запрос
              рассматривается в течение 10 рабочих дней.
            </P>
            <P>
              Жалобу в Роскомнадзор можно подать через{" "}
              <A href="https://rkn.gov.ru/treatments/ask-question/">форму обращений на сайте ведомства</A>.
            </P>
          </Part>

          <Part n="9" title="Отзыв согласия">
            <P>
              Чтобы отозвать согласие на обработку персональных данных, напишите об этом
              оператору любым из указанных в разделе 2 способов, указав контакт, под которым
              была отправлена заявка. После отзыва согласия обработка прекращается, а данные
              удаляются в течение 10 рабочих дней, кроме случаев, когда более долгое хранение
              требуется законодательством РФ (например, при уже возникшем налоговом или ином
              обязательном учёте).
            </P>
          </Part>

          <Part n="10" title="Меры защиты">
            <P>Для защиты персональных данных применяются:</P>
            <ul className="list-disc list-outside pl-6 space-y-2">
              <Li>шифрование соединения между браузером и сервером (HTTPS/TLS, сертификат Let's Encrypt);</Li>
              <Li>ограничение частоты отправки формы на уровне сервера (nginx): не более 6 заявок в минуту с одного IP-адреса, как защита от массовых автоматических заявок;</Li>
              <Li>скрытое поле в форме, которое заполняют только боты: такие заявки отсеиваются без участия человека;</Li>
              <Li>проверка полей формы и ограничение их длины на сервере;</Li>
              <Li>токен бота в Telegram хранится только на сервере оператора.</Li>
            </ul>
          </Part>

          <Part n="11" title="Cookie и аналитика">
            <P>
              На момент публикации этой редакции сайт не использует аналитические счётчики,
              рекламные пиксели и cookie-файлы для отслеживания поведения посетителей. Если в
              будущем на сайт будет подключена аналитика (например, Яндекс.Метрика), этот
              раздел будет обновлён до её включения, с описанием того, что именно собирается
              и как от этого можно отказаться.
            </P>
          </Part>

          <Part n="12" title="Изменение политики">
            <P>
              Оператор может изменять эту политику. Новая редакция вступает в силу с момента
              публикации на этой странице; дата редакции указана в начале документа. При
              существенных изменениях состава собираемых данных или целей обработки дата
              редакции обновляется, а изменения актуальны для заявок, отправленных после
              публикации новой редакции.
            </P>
          </Part>

      <div className="mt-12 border-t border-ink-4 pt-12">
        <p className="font-mono text-sm text-muted">
          Разбор бесплатный и ни к чему не обязывает, отправка формы не создаёт договор и
          не порождает финансовых обязательств ни для одной из сторон.
        </p>
      </div>
    </LegalPage>
  );
}
